import TabContext from "@mui/lab/TabContext";
import {
  CircularProgress,
  MenuItem,
  Slide,
  tabsClasses,
  Typography,
  useTheme,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DownloadJd,
  getJdFileList,
  getMatchedJdResumeData,
} from "../../../api/Api";
import CandidateAddIco from "../../../assets/icons/CandidateAddIco";
import CandidateHub from "../../../assets/icons/CandidateHub";
import CandidateSupportIco from "../../../assets/icons/CandidateSupportIco";
import ReportBugIco from "../../../assets/icons/ReportBugIco";
import SourceCandidateIco from "../../../assets/icons/SourceCandidateIco";
import SupportIco from "../../../assets/icons/SupportIco";
import UploadResumeIco from "../../../assets/icons/UploadResumeIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import {
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../redux/action/ChatBot";
import { FeedBackButton } from "../../../redux/action/Feedback";
import {
  checkBackGroundProcess,
  GetJobDataDetail,
  JobCandidateResume,
  JobJobFormikData,
  JobJobSubmit,
  JobSummary,
} from "../../../redux/action/Job";
import { MinimizeIcon } from "../../../redux/action/Login";
import { UploadJob } from "../../../redux/action/QuickMatch";
import { GET, GETDOWNLOAD } from "../../../redux/axios/Axios";
import {
  HandleSkeletion,
  rebuildSourceFromFinalData,
} from "../../../utils/constants";
import ChatBotLabelText from "../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  StyledFlexRowView,
  TabPanelView,
  TabViewSection,
} from "../../common-components/StyledComponents";
import AddMoreCandidate from "../../matches/quick-match/components/AddMoreCandidate";
import DownloadJD from "../job-information/download-jd";
import JobInformation from "../job-information/index";
import JobsCandidate from "../jobs-candidate";
import DialogCandidateHub from "../jobs-candidate/components/DialogCandidateHub";
import JobsSummary from "../jobs-summary";
import { CustomizeMenu, CustomizeSpan, EllipseData } from "../style";

export default function JobsView() {
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const jobStatus = query.get("status");
  const getBreadcrumb = query.get("breadcrumbs");
  const chatBot = query.get("chatBot");
  const [value, setValue] = React.useState(query?.get("value") || "0");
  const [jobData, setJobData] = React.useState({});
  const [openDownloadJdDialog, setOpenDownloadJdDialog] = React.useState(false);
  const [jdFileList, setJdFileList] = React.useState([]);
  const [jdFileListLoader, setJdFileListLoader] = React.useState(false);
  const dispatch = useDispatch();
  const [resumeTab, setResumeTab] = React.useState([]);
  const [resumeScore, setResumeScore] = React.useState([]);
  const resumeId = resumeTab[value - 2]?.id;
  const filteredResumeTab = [
    ...resumeTab,
    ...(jobData?.hiring_manager || []),
    ...(jobData?.golden_record || []),
  ].filter((item) => item.id !== resumeId);
  const [matchedData, setMatchedData] = React.useState({
    matchedData: {},
    search_analysis: "",
    search_analysis_loading: true,
  });
  const [resumeLoader, setResumeLoader] = React.useState(false);
  const valueLocation = useLocation().search;
  const navigate = useNavigate();
  const theme = useTheme();
  const SummaryJobData = useSelector((state) => state.jobs.jobSummary);
  const [isLoading, setIsLoading] = React.useState(false);
  const [tableLoader, setTableLoader] = React.useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    React.useState(false);
  const [isAddMoreCandidateDragging, setIsAddMoreCandidateDragging] =
    React.useState(false);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = React.useState([]);
  const [isBackgroundRunning, setIsBackgroundRunning] = React.useState(false);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    message: "",
    severity: "error",
  });
  const questionMarkItemRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const addToJobPoolData = useSelector((state) => state.candidate.addToJobPool);
  const isJobPoolProcessRunning = addToJobPoolData?.data?.some(
  (item) => item.status === "Inprogress" && item.job_id === jobId  
);
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const [saveEditData, setSaveEditData] = React.useState({
    open: false,
    prevData: "",
    leaveLoading: false,
    disabled: false,
    saveLoading: false,
    view: false,
  });
  const buttonSupport = [
    {
      name: "Job",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEditData);
  const tabData = ["Summary", "Job"];
  const [backGroundprocess, setBackGroundprocess] = React.useState({
    open: false,
    disabled: false,
    openLoading: false,
    buttonLoading: false,
    hiringLoading: false,
    goldenLoading: false,
    type: "Candidate",
  });
  const [open, setOpen] = React.useState(false);
  const [chatBotData, setChatBotData] = React.useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    geminiBubble: [],
    bubbleCondition: false,
    selectedValue: "Job",
    details: "Hide Details",
    expandDrawer: false,
  });
  const [isBottomVisible, setIsBottomVisible] = React.useState(true);

  const handleChange = (event, newValue) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      setSaveEditData((prev) => ({
        ...prev,
        open: true,
        prevData: newValue,
        view: false,
      }));
    } else {
      setValue(newValue);
      const index = newValue - 2;
      const resumeId = resumeTab[newValue - 2]?.id;
      const urlParams = new URLSearchParams(valueLocation);
      urlParams.delete("value");
      urlParams.append("value", newValue);
      urlParams.delete("match-id");
      if (newValue && parseInt(newValue) >= 2) {
        urlParams.append("match-id", resumeId);
      }
      if (
        getBreadcrumb !== null &&
        getBreadcrumb !== "null" &&
        getBreadcrumb !== "undefined"
      ) {
        urlParams.append("breadcrumbs", getBreadcrumb);
      }
      const newUrl = `/jobs/jobs-view?${urlParams.toString()}`;
      navigate(newUrl);
      if (newValue && parseInt(newValue) >= 2) {
        fetchResumeData(resumeId, index);
      }
    }
  };

  const handleSaveCandidate = () => {
    setSaveEditData({
      open: false,
      prevData: "",
      leaveLoading: false,
      disabled: false,
      saveLoading: false,
      view: false,
    });
  };

  const handlebackGroundWarningClose = () => {
    setIsBackgroundRunning(false); 
    setBackGroundprocess({
      open: false,
      disabled: false,
      openLoading: false,
      buttonLoading: false,
      hiringLoading: false,
      goldenLoading: false,
    });
  };

  const handlebackGroundWarning = () => {
    setBackGroundprocess((prev) => ({
      ...prev,
      buttonLoading: true,
    }));
    setTimeout(() => {
      handlebackGroundWarningClose();
    }, 1000);
  };

  const handleClick = () => {
    setSaveEditData((prev) => ({
      ...prev,
      open: true,
      prevData: "1",
      view: false,
    }));
  };
  const [pageTitle, setPageTitle] = React.useState(query.get("title") || "");
  const breadCrumbData = [
    ...(getBreadcrumb &&
    getBreadcrumb !== "null" &&
    getBreadcrumb !== "undefined"
      ? [
          {
            title: "Work Flow",
            navigate: `/job-krystal-path`,
            ...(JSON.stringify(JobJobEditData.formikData) !==
              JSON.stringify(JobJobEditData.jobData) && {
              onClick: handleClick,
            }),
          },
        ]
      : [
          {
            title: "Jobs",
            navigate: `/jobs`,
            ...(JSON.stringify(JobJobEditData.formikData) !==
              JSON.stringify(JobJobEditData.jobData) && {
              onClick: handleClick,
            }),
          },
        ]),
    {
      title: pageTitle,
      active: true,
    },
  ];

  const fetchJobDataDetail = async (condition) => {
    if (jobId) {
      setTableLoader(true);
      setResumeLoader(true);
      try {
        let params = {};
        if (
          localStorageData?.organization === "Demo" &&
          localStorageData?.role === "Demo" &&
          (condition || query.get("is_demo") === "true")
        ) {
          params = {
            is_demo: true,
          };
        }
        const res = await GetJobDataDetail(jobId, params);
        setJobData(res?.data);
        setResumeTab(res?.data?.resumes || []);
        setResumeScore(res?.data?.rescore_resumes || []);
        const queryValue = query?.get("value");
        const resumeData = res?.data?.resumes;

        if (queryValue >= "2" && resumeData.length !== 0) {
          const data = resumeData[queryValue - 2]?.id;
          const index = queryValue - 2;
          setValue(queryValue);
          await fetchResumeData(data, index, resumeData, "");
        } else if (queryValue === "1") {
          setValue(queryValue);
        }
        setTableLoader(false);
        setResumeLoader(false);
      } catch (error) {
        setTableLoader(false);
        setResumeLoader(false);
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message,
        });
        console.error("Error fetching job data:", error);
      }
    } else {
      console.error("Job ID is not provided in the URL.");
    }
  };

  const fetchResumeData = async (resumeId, index, resumeObj, paramLabel) => {
    setResumeLoader(true);

    try {
      const data = await GET(getMatchedJdResumeData(resumeId), paramLabel);
      let arr = [...(resumeObj ? resumeObj : resumeTab)];
      let detailObj = {
        ...data?.data,
        candidate_name: data?.data?.resume_info?.candidate_name,
        name: (resumeObj ? resumeObj : resumeTab)?.[index]?.name,
        pay_rate: data?.data?.resume_info?.pay_rate,
        location: data?.data?.resume_info?.location,
        inferred_title: data?.data?.resume_info?.inferred_title,
        visa_info: data?.data?.resume_info?.visa_info,
        website: data?.data?.resume_info?.website,
        email: data?.data?.resume_info?.email,
        overall_score: data?.data?.quick_match_score?.overall_score,
        results: data?.data?.results || [],
        skill_calculation: data?.data?.skill_calculation,
        error_message: data?.data?.error_message,
        resume_id: data?.data?.resume_id,
        spider_graph_results: data?.data?.spider_graph_results,
        file_name: data?.data?.resume_file_name,
        insights: data?.data?.insights,
        feedback: data?.data?.feedback,
        match_summary: data?.data?.match_summary,
        experience: data?.data?.experience,
        coversheet_added: data?.data?.coversheet_added,
        data: {
          personal_details: {
            candidate_name: data?.data?.resume_info?.candidate_name,
            inferred_title: data?.data?.resume_info?.inferred_title,
          },
        },
      };
      if (arr[index]) {
        arr[index] = {
          ...arr[index],
          details: detailObj,
        };
      }

      if (arr.length === 0) {
        setValue("0");
      }

      setResumeTab(arr);
      setMatchedData((prev) => ({
        ...prev,
        matchedData: arr[index]?.details || {},
        search_analysis_loading: false,
      }));

      setResumeLoader(false);
      // setMatchedData((prev) => ({
      //   ...prev,
      //   search_analysis_loading: true,
      // }));
      // const analysis = await JobCandidateAnalysis(resumeId);
      // setMatchedData((prev) => ({
      //   ...prev,
      //   search_analysis: analysis.data || "",
      //   search_analysis_loading: false,
      // }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.response?.data?.message,
      });
      setResumeLoader(false);
    }
  };

  React.useEffect(() => {
    fetchJobDataDetail();
    if (chatBot === "true") {
      setOpen(true);
    }
  }, [jobId]);
  React.useEffect(() => {
  const checkOnMount = async () => {
    if (!jobId) return;
    try {
      const data = await checkBackGroundProcess(jobId);
      setIsBackgroundRunning(data?.background_process_status);
    } catch (error) {
      setSnackbarState({
          open: true,
          severity: "error",
          message:
            "An unexpected error occurred while parsing the error message.",
          });
    }
  };
  checkOnMount();
}, [jobId]);

  const handleCloseDownloadJdDialog = () => {
    setOpenDownloadJdDialog(false);
  };

  const handleDownloadJd = (row) => {
    if (row.id) {
      GETDOWNLOAD(DownloadJd(row.id), {
        params: { type: "match_resume" },
        responseType: "blob",
      })
        .then((response) => {
          const contentType = response.headers["content-type"];
          const extension =
            contentType === "application/pdf"
              ? "pdf"
              : contentType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              ? "docx"
              : "doc";

          const fileName = `${row?.file_name}.${extension}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "JD was not parsed successfully. Unable to download.",
      });
    }
  };

  const fetchJdFileList = async () => {
    setJdFileListLoader(true);
    if (jobId) {
      try {
        const res = await GET(getJdFileList(jobId));
        if (res?.success) {
          setJdFileList(res?.data);
          setJdFileListLoader(false);
        }
      } catch (error) {
        setJdFileListLoader(false);
      }
    }
  };

  const handleDownloadJdOpen = () => {
    setOpenDownloadJdDialog(true);
    fetchJdFileList();
  };

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];

    setCommonFiles(mergedFiles);

    const existing = JSON.parse(localStorage.getItem("job_candidate")) || {};
    let checkData = {
      file: mergedFiles.map((f) => ({
        ...f,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: false,
        file: {
          name: f.file.name,
          size: f.file.size,
          type: f.file.type,
          lastModified: f.file.lastModified,
          ...f.file,
        },
      })),
    };
    const updated = {
      ...existing,
      [jobId]: {
        ...existing[jobId],
        file: checkData.file,
        status: "Inprogress",
      },
    };
    localStorage.setItem("job_candidate", JSON.stringify(updated));
    dispatch(
      JobCandidateResume({
        id: jobId,
        file: updated[jobId].file,
        status: "Inprogress",
      })
    );

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleAddMoreCandidateDialogClose = () => {
    setAddMoreCandidateDialogOpen(false);
    setAddMoreCandidateFiles([]);
  };

  const handleAddMoreCandidateOpen = async ({ condition }) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      handleClick();
    } else {
      setBackGroundprocess((prev) => ({
        ...prev,
        disabled: true,
        openLoading: condition === "CANDIDATE" ? true : false,
        hiringLoading: condition === "HIRING MANAGER" ? true : false,
        goldenLoading: condition === "GOLDEN RECORD" ? true : false,
      }));
      try {
        const data = await checkBackGroundProcess(jobId);
        if (!data?.background_process_status) {
          setIsLoading(false);
          setAddMoreCandidateDialogOpen(true);
        }
        setBackGroundprocess((prev) => ({
          ...prev,
          disabled: false,
          open: data?.background_process_status,
          openLoading: false,
          hiringLoading: false,
          goldenLoading: false,
          type: condition,
        }));
      } catch (error) {
        setBackGroundprocess((prev) => ({
          ...prev,
          disabled: false,
          openLoading: false,
          hiringLoading: false,
          goldenLoading: false,
        }));
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    }
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleAddMoreCandidateDeleteFile = (index) => {
    setAddMoreCandidateFiles((prevFiles) =>
      prevFiles.filter((_, i) => i !== index)
    );
  };

  const handleAddMoreCandidateDragOver = (event) => {
    event.preventDefault();
    setIsAddMoreCandidateDragging(true);
  };

  const handleAddMoreCandidateDragLeave = () => {
    setIsAddMoreCandidateDragging(false);
  };

  const handleAddMoreCandidateDrop = (event) => {
    event.preventDefault();
    setIsLoading(false);
    setIsAddMoreCandidateDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const processJsonResponse = (
    jsonResponse,
    getName,
    setCandidateFiles,
    getAddMore
  ) => {
    const { success, data, message } = jsonResponse;
    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("job_candidate"));
      const getData = storedData?.[jobId]?.file?.map((f) =>
        f.name === data.current_resume
          ? {
              ...f,
              progress: data.percent,
              buffer: data.buffer || data.percent,
              visible: false,
              delete: false,
              progress_message: data.progress_message,
            }
          : f
      );
      const updated = {
        ...storedData,
        [jobId]: {
          ...storedData[jobId],
          file: getData,
          status: "Inprogress",
        },
      };

      localStorage.setItem("job_candidate", JSON.stringify(updated));

      dispatch(
        JobCandidateResume({
          id: jobId,
          file: getData,
          status: "Inprogress",
        })
      );

      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume
            ? {
                ...f,
                progress: data.percent,
                buffer: data.buffer || data.percent,
                visible: false,
                delete: false,
                progress_message: data.progress_message,
              }
            : f
        )
      );
    } else if (
      getAddMore === "Add-more-Candidate" &&
      data &&
      data?.length > 0
    ) {
      setAddMoreCandidateDialogOpen(false);
      setAddMoreCandidateFiles([]);
      if (Array.isArray(data) && data.length > 0 && data[0]?.jd_info) {
        let responseId = data[0]?.id;
        let arr = [...resumeTab];
        let resumeObj = {
          id: responseId,
          name: data[0]?.resume_info?.candidate_name
            ? data[0]?.resume_info?.candidate_name
            : "",
          score: data[0]?.quick_match_score?.overall_score
            ? data[0]?.quick_match_score?.overall_score
            : data[0]?.score,
          file_name: data[0]?.resume_file_name,
        };
        arr.push(resumeObj);
        setResumeTab(arr);
        fetchSummaryDetails();
        fetchJobDataDetail();

        const storedData = JSON.parse(localStorage.getItem("job_candidate"));
        const updated = {
          ...storedData,
          [jobId]: {
            ...storedData[jobId],
            file: [],
            status: "success",
          },
        };
        localStorage.setItem("job_candidate", JSON.stringify(updated));
        dispatch(
          JobCandidateResume({
            id: jobId,
            file: [],
            status: "success",
          })
        );
      }
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("job_candidate"));
      const getData = storedData?.[jobId]?.file?.map((f) =>
        f.name === data.current_resume
          ? {
              ...f,
              visible: true,
              message: message,
              delete: true,
            }
          : { ...f, delete: true }
      );
      const updated = {
        ...storedData,
        [jobId]: {
          ...storedData[jobId],
          file: getData,
          status: "fail",
        },
      };
      localStorage.setItem("job_candidate", JSON.stringify(updated));
      dispatch(
        JobCandidateResume({
          id: jobId,
          file: getData,
          status: "fail",
        })
      );

      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume || data.length === 0
            ? {
                ...f,
                visible: true,
                delete: true,
                message: message,
              }
            : { ...f, delete: true }
        )
      );
    }
  };

  const fetchSummaryDetails = async (condition) => {
    try {
      setTableLoader(true);
      let params = {};
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo" &&
        (condition || query.get("is_demo") === "true")
      ) {
        params = {
          is_demo: true,
        };
      }
      await dispatch(JobSummary(jobId, params));
      setTableLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error?.data?.message || error?.message,
        severity: "error",
      });
      setTableLoader(false);
    }
  };

  const uploadFile = async (getName, setCandidateFiles, getAddMore) => {
    setIsLoading(true);

    setCandidateFiles((prevFiles) =>
      prevFiles.map((f) => ({
        ...f,
        delete: false,
      }))
    );

    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      try {
        const urlParams = new URLSearchParams(valueLocation);
        urlParams.delete("value");
        urlParams.append("is_demo", true);
        const newUrl = `/jobs/jobs-view?${urlParams.toString()}`;
        navigate(newUrl);

        let progress = 0;

        const updateProgress = async () => {
          progress += 10;

          setCandidateFiles((prevFiles) =>
            prevFiles.map((item, index) => ({
              ...item,
              progress,
              buffer: progress,
              visible: false,
              delete: false,
            }))
          );

          if (progress >= 100) {
            setTimeout(async () => {
              setAddMoreCandidateDialogOpen(false);
              setAddMoreCandidateFiles([]);
              setIsLoading(true);

              await fetchSummaryDetails(true);
              await fetchJobDataDetail(true);

              setIsLoading(false);
              setSnackbarState({
                open: true,
                message: "Update Successfully",
                severity: "success",
              });
            }, 500);
            return;
          }

          setTimeout(updateProgress, 300);
        };

        updateProgress();
      } catch (error) {
        setSnackbarState({
          open: true,
          message: "Error parsing JSON",
          severity: "error",
        });
      }
    } else {
      const formData = new FormData();

      addMoreCandidateFiles.forEach((fileObj, index) => {
        formData.append("resume_file", fileObj.file);
      });
      formData.append("type", backGroundprocess.type);
      formData.append("id", jobId);

      try {
        const response = await UploadJob(formData, getName, "Active");
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(
                jsonResponse,
                getName,
                setCandidateFiles,
                getAddMore
              );
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("job_candidate")
              );
              const getData = storedData?.[jobId]?.file?.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                      message: e.message,
                    }
                  : { ...f }
              );
              const updated = {
                ...storedData,
                [jobId]: {
                  ...storedData[jobId],
                  file: getData,
                  status: "fail",
                },
              };
              localStorage.setItem("job_candidate", JSON.stringify(updated));
              dispatch(
                JobCandidateResume({
                  id: jobId,
                  file: getData,
                  status: "fail",
                })
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                      }
                    : { ...f, delete: true }
                )
              );
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(
              jsonResponse,
              getName,
              setCandidateFiles,
              getAddMore
            );
          } catch (e) {
            const storedData = JSON.parse(
              localStorage.getItem("job_candidate")
            );
            const getData = storedData?.[jobId]?.file?.map((f) =>
              f.name === jsonResponse.data.current_resume
                ? {
                    ...f,
                    visible: true,
                    delete: true,
                    message: jsonResponse.message,
                  }
                : { ...f, delete: true }
            );
            const updated = {
              ...storedData,
              [jobId]: {
                ...storedData[jobId],
                file: getData,
                status: "fail",
              },
            };
            localStorage.setItem("job_candidate", JSON.stringify(updated));
            dispatch(
              JobCandidateResume({
                id: jobId,
                file: getData,
                status: "fail",
              })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setCandidateFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                    }
                  : { ...f, delete: true }
              )
            );
          }
        }
        setIsLoading(false);
      } catch (error) {
        const storedData = JSON.parse(localStorage.getItem("job_candidate"));
        const getData = storedData?.[jobId]?.file?.map((f) => ({
          ...f,
          visible: true,
          delete: true,
          message: '"Error during the request',
        }));
        const updated = {
          ...storedData,
          [jobId]: {
            ...storedData[jobId],
            file: getData,
            status: "fail",
          },
        };
        localStorage.setItem("job_candidate", JSON.stringify(updated));
        dispatch(
          JobCandidateResume({
            id: jobId,
            file: getData,
            status: "fail",
          })
        );

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );

        setIsLoading(false);
      }
    }
  };

  const handleAddMoreCandidateClick = async () => {
    if (addMoreCandidateFiles.length === 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      uploadFile(
        "Upload-Candidate",
        setAddMoreCandidateFiles,
        "Add-more-Candidate"
      );
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleLeave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      leaveLoading: true,
    }));
    await dispatch(
      JobJobFormikData(JobJobEditData.formikData, JobJobEditData.formikData)
    );
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        leaveLoading: false,
        open: false,
        view: prev.prevData === "1" ? true : false,
      }));

      callBack(saveEditData.prevData);
    } catch (error) {}
  };

  const handleSave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));

    const values = JobJobEditData.jobData;
    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...JobJobEditData,
      ...values,
      employer_targets: result(values.employer_targets),
      certificates: result(values.certificates),
      languages: result(values.languages),
      shift: result(values.shift),
      visa_status: rebuildSourceFromFinalData(values.visa_status),
      location_targets: result(values.location_targets),
      high_priority: values.skillData.high_priority,
      low_priority: values.skillData.low_priority,
      medium_priority: values.skillData.medium_priority,
      recommended: values.skillData.recommended,
      industry: rebuildSourceFromFinalData(values.industry),
      required_years_for_industry: {
        months: JobJobEditData.required_years_for_industry?.months,
        years: parseInt(values.required_years_for_industry),
      },
    };

    try {
      dispatch(JobJobFormikData(values, values));
      const jobEdit = await JobJobSubmit(values.id, data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        open: false,
        view: prev.prevData === "1" ? true : false,
      }));
      callBack(saveEditData.prevData);
    } catch (error) {
      dispatch(JobJobFormikData(JobJobEditData.jobData, values));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        view: false,
      }));
    }
  };

  const callBack = (newValue) => {
    setValue(newValue);
    const index = newValue - 2;
    const resumeId = resumeTab[newValue - 2]?.id;
    const urlParams = new URLSearchParams(valueLocation);
    urlParams.delete("value");
    urlParams.append("value", newValue);
    const newUrl = `/jobs/jobs-view?${urlParams.toString()}`;
    navigate(newUrl);
    if (newValue && parseInt(newValue) >= 2) {
      fetchResumeData(resumeId, index);
    }
  };

  const functionCall = async () => {
    if (chatBotData.selectedValue === "Support") {
      handleSupportCall();
    } else {
      await handleChatBotCandidateCall();
      if (questionMarkItemRef.current) {
        handleButtonClickByLabel(questionMarkItemRef.current);
      }
    }
    if (parseInt(value) >= 2) {
      setChatBotData((prev) => ({
        ...prev,
        bubbleCondition: true,
      }));
    } else {
      setChatBotData((prev) => ({
        ...prev,
        bubbleCondition: false,
      }));
    }
  };

  React.useEffect(() => {
    functionCall();
  }, [value]);

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        color="#344054"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        border={"#D0D5DD"}
        onClick={handleLeave}
        disabled={saveEditData.disabled}
        loading={saveEditData.leaveLoading}
      />
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={saveEditData.disabled}
        loading={saveEditData.saveLoading}
        onClick={handleSave}
      />
    </CommonGrid2>
  );

  const BackGroundFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"OK"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handlebackGroundWarning}
        disabled={backGroundprocess.disabled}
        loading={backGroundprocess.buttonLoading}
      />
    </CommonGrid2>
  );

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));

    let params = {
      match_id: resumeId,
    };
    try {
      const data = await ChatBotGetCall(jobId, params);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });
      const jobBubbleFilter = data?.data?.bubble_questions.filter(
        (item) => item.module_name === "Job"
      );
      const matchBubbleFilter = data?.data?.bubble_questions.filter(
        (item) => item.module_name === "Match"
      );

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        geminiBubble:
          value === "0"
            ? []
            : value === "1"
            ? jobBubbleFilter
            : matchBubbleFilter,
        pageLoader: false,
        details: messages.length === 0 ? "Hide Details" : "See Details",
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: jobId,
        },
        ...(value >= 2 ? { match_id: resumeId } : {}),
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleButtonClickByLabel = async (item) => {
    const senderResponse = {
      sender: "user",
      text: item.question,
    };
    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, senderResponse],
      loader: true,
    }));
    setChatBotData((prev) => ({
      ...prev,
      arrow: true,
    }));

    let payload = {
      query: item.prompt,
      filter_criteria: {
        type: "match_data",
        job_data_id: jobId,
      },
      match_id: resumeId,
    };

    try {
      const data = await dispatch(ChatBotCall(payload));
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
    questionMarkItemRef.current = null;
  };

  const handleQuestionMarkClick = (item) => {
    questionMarkItemRef.current = item;
    setOpen((prev) => {
      dispatch(MinimizeIcon(false, true));
      return true;
    });
    functionCall();
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));

    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        geminiBubble: data?.data?.bubble_questions,

        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotCandidateCall();
    }
  };

  const handleToggleDrawer = () => {
    if (chatBotData.selectedValue === "Support") {
      handleChatBotCandidateCall();
    }
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleActivityChange = () => {
    setChatBotData((prev) => ({
      ...prev,
      details: prev.details === "See Details" ? "Hide Details" : "See Details",
    }));
  };

  const handleMenuClick = (event) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      handleClick();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      label: "Upload Resumes",
      icon: backGroundprocess.openLoading ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <UploadResumeIco />
      ),
      disabled:
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled" ||
        backGroundprocess.disabled,
      onClick: async () => {
        await handleAddMoreCandidateOpen({ condition: "CANDIDATE" });
        await handleMenuClose();
      },
    },

    {
      label: "Source Candidates",
      disabled:
        
        isLoading || isJobPoolProcessRunning || isBackgroundRunning ||  
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled" ||
        backGroundprocess.disabled,
      icon: <SourceCandidateIco />,
      onClick: () => {
        const urlParams = new URLSearchParams(valueLocation);
        const newUrl = `/jobs/jobs-view/candidate-scoring?${urlParams.toString()}`;
        navigate(newUrl);
      },
    },
    {
      label: "Upload Hiring Manager",
      icon: backGroundprocess.hiringLoading ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <UploadResumeIco />
      ),
      disabled:
        SummaryJobData?.results?.hiring_manager?.length > 0 ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled" ||
        backGroundprocess.disabled,
      onClick: async () => {
        await handleAddMoreCandidateOpen({ condition: "HIRING MANAGER" });
        await handleMenuClose();
      },
    },
    {
      label: "Upload Golden Record",
      icon: backGroundprocess.goldenLoading ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <UploadResumeIco />
      ),
      disabled:
        SummaryJobData?.results?.golden_record?.length > 0 ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled" ||
        backGroundprocess.disabled,
      onClick: async () => {
        await handleAddMoreCandidateOpen({ condition: "GOLDEN RECORD" });
        await handleMenuClose();
      },
    },
    // {
    //   label: "Add from Candidate Hub",
    //   icon: <AddFromCandidateHubIco />,
    //   disabled: backGroundprocess.openLoading,
    // },
  ];

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <TabContext value={value}>
        <CommonGrid2
          width={
            open
              ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
              : "100%"
          }
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          borderRadius={"10px"}
          height={"fit-content"}
          padding={"1rem"}
          margin={"1.35rem 1rem 1.35rem 1.35rem"}
          position={"relative"}
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
        >
          <Breadcrumbs breadCrumbData={breadCrumbData} />
          <CommonGrid2
            container
            spacing={2}
            alignItems="center"
            marginTop={2.5}
            justifyContent={"space-between"}
          >
            <CommonGrid2 item size={{ xs: 12, md: 11, sm: 10 }}>
              <TabViewSection
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="visible arrows tabs example"
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    "&.Mui-disabled": { opacity: 0.3 },
                  },
                }}
              >
                {tabData.map((item, index) => (
                  <Tab
                    label={item}
                    value={index.toString()}
                    disabled={chatBotData.loader}
                  />
                ))}

                {resumeTab?.map((elt, index) => {
                  return tableLoader ? (
                    <HandleSkeletion
                      width="100px"
                      height="45px"
                      margin={"0px 1rem 0px 0px"}
                    />
                  ) : (
                    <Tab
                      label={
                        <CustomTooltip
                          fontSize="12px"
                          fontWeight="600"
                          title={elt?.name ? elt.name : elt?.file_name}
                        >
                          <EllipseData
                            whiteSpace="nowrap"
                            textOverflow="ellipsis"
                            verticalAlign="middle"
                            padding="10px 0px"
                            maxWidth="175px"
                            display=""
                          >
                            <CustomizeSpan
                              border="1px solid #EAECF0"
                              borderRadius="50px"
                              background="#fff"
                              padding="6px 3px"
                              margin="0px 5px 0px 0px"
                            >
                              <CustomizeSpan
                                color="#fff"
                                padding={index === 0 ? "3px 9px" : "3px 8px"}
                                borderRadius="50%"
                                background={
                                  index === 0
                                    ? "#079455"
                                    : index === 1
                                    ? "#F79009"
                                    : "#FF5C77"
                                }
                              >
                                {" "}
                                {index + 1}
                              </CustomizeSpan>{" "}
                              {elt?.score}%{"  "}
                            </CustomizeSpan>
                            {elt?.name
                              ? elt.name.split(" ")[0]
                              : elt?.file_name}
                          </EllipseData>
                        </CustomTooltip>
                      }
                      value={(index + tabData.length).toString()}
                      key={index + tabData.length}
                      disabled={chatBotData.loader}
                      sx={{
                        textTransform: "none",
                        "&.Mui-selected": {
                          color: "black",
                          fontWeight: "bold",
                        },
                      }}
                    />
                  );
                })}
              </TabViewSection>
            </CommonGrid2>
            <CommonGrid2 item size={{ xs: 12, md: 1, sm: 2 }} textAlign={"end"}>
              <CommonButton
                value={<CandidateAddIco />}
                // padding={"13px 14px"}
                variant="outlined"
                color={"#344054"}
                border={"#D0D5DD"}
                fontWeight={"600"}
                svg={true}
                aria-controls={menuOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? "true" : undefined}
                onClick={handleMenuClick}
                // minWidth={"20px !important"}
                padding="10px 15px"
                minWidth={"auto"}
              />

              <CustomizeMenu
                id="basic-menu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {menuItems.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={item.disabled ? () => {} : item.onClick}
                    aria-controls={item.ariaControls}
                    aria-haspopup={item.ariaHasPopup}
                    aria-expanded={item.ariaExpanded}
                    style={{ opacity: item.disabled ? 0.5 : 1 }}
                    disabled={item?.disabled}
                  >
                    <StyledFlexRowView>
                      {item.icon}
                      <Typography>{item.label}</Typography>
                    </StyledFlexRowView>
                  </MenuItem>
                ))}
              </CustomizeMenu>
            </CommonGrid2>
          </CommonGrid2>

          <Slide
            direction="up"
            in={value === "0"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="0" padding="2rem 0px 0px">
              <JobsSummary fetchData={fetchJobDataDetail} />
            </TabPanelView>
          </Slide>

          <Slide
            direction="up"
            in={value === "1"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="1" padding="2rem 0px 0px">
              <JobInformation
                jobData={jobData}
                jobId={jobId}
                handleDownloadJdOpen={handleDownloadJdOpen}
                fetchData={fetchJobDataDetail}
                handleClick={handleClick}
                saveEditData={saveEditData}
                resumeTab={resumeScore}
                onTitleUpdate={(newTitle) => {  
                  setPageTitle(newTitle);
                  const urlParams = new URLSearchParams(window.location.search);
                  urlParams.set("title", newTitle);
                  window.history.replaceState(null, "", `/jobs/jobs-view?${urlParams.toString()}`);
                }}
              />
            </TabPanelView>
          </Slide>
          {resumeTab.map((elt, index) => (
            <Slide
              direction="up"
              in={value === (index + tabData.length).toString()}
              timeout={500}
              mountOnEnter
              unmountOnExit
            >
              <TabPanelView
                value={(index + tabData.length).toString()}
                padding="2rem 0px 0px"
                key={index + tabData.length}
              >
                <JobsCandidate
                  matchedData={matchedData.matchedData}
                  resumeId={resumeId}
                  resumeLoader={resumeLoader}
                  filteredResumeTab={filteredResumeTab}
                  fetchResumeData={fetchResumeData}
                  fetchData={fetchJobDataDetail}
                  handleQuestionMarkClick={handleQuestionMarkClick}
                  iconVisible={
                    chatBotData.selectedValue === "Support"
                      ? false
                      : !chatBotData.loader && !chatBotData.pageLoader
                  }
                  open={open}
                  chatBotData={chatBotData}
                  jobData={jobData}
                />
              </TabPanelView>
            </Slide>
          ))}
        </CommonGrid2>
        <CommonGrid2
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
          width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          top={"0px"}
          position={"sticky"}
          right={"0"}
          height={"100%"}
          overflowY={"auto"}
          scrollStyle
          scrollBar="5px"
        >
          {open && (
            <CommonGrid2
              padding={"0rem 1rem 1rem"}
              height={"100%"}
              justifyContent={"space-between"}
              display={"flex"}
              flexDirection={"column"}
            >
              <SideBarChatBot
                handleToggleDrawer={handleToggleDrawer}
                jobId={jobId}
                chatBotData={chatBotData}
                handleSendMessage={handleSendMessage}
                handleChatBotChange={handleChatBotChange}
                isBottomVisible={isBottomVisible}
                setIsBottomVisible={setIsBottomVisible}
                handleUpArrow={handleUpArrow}
                handleButtonClickByLabel={handleButtonClickByLabel}
                userName={storageData?.username}
                buttonSupport={buttonSupport}
                handleButtonSupport={handleButtonSupport}
                handleActivityChange={handleActivityChange}
                handleExpandDrawer={handleExpandDrawer}
              />
            </CommonGrid2>
          )}
        </CommonGrid2>
      </TabContext>

      {/* Download JD Dailog */}
      <DownloadJD
        openDownloadJdDialog={openDownloadJdDialog}
        handleCloseDownloadJdDialog={handleCloseDownloadJdDialog}
        jdFileList={jdFileList}
        handleDownloadJd={handleDownloadJd}
        jdFileListLoader={jdFileListLoader}
      />

      {/* Add Candidate Resume */}
      <AddMoreCandidate
        addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
        handleAddMoreCandidateDialogClose={handleAddMoreCandidateDialogClose}
        handleAddMoreCandidateDragOver={handleAddMoreCandidateDragOver}
        handleAddMoreCandidateDragLeave={handleAddMoreCandidateDragLeave}
        handleAddMoreCandidateDrop={handleAddMoreCandidateDrop}
        handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        addMoreCandidateFiles={addMoreCandidateFiles}
        isAddMoreCandidateDragging={isAddMoreCandidateDragging}
        handleAddMoreCandidateDeleteFile={handleAddMoreCandidateDeleteFile}
        handleAddMoreCandidateClick={handleAddMoreCandidateClick}
        isLoading={isLoading}
        disabled={
          (backGroundprocess.type === "HIRING MANAGER" ||
            backGroundprocess.type === "GOLDEN RECORD") &&
          addMoreCandidateFiles.length !== 0
        }
        isJem={
          backGroundprocess.type === "HIRING MANAGER" ||
          backGroundprocess.type === "GOLDEN RECORD"
            ? true
            : false
        }
        title={
          backGroundprocess.type === "HIRING MANAGER"
            ? "Add Hiring Manager"
            : backGroundprocess.type === "GOLDEN RECORD"
            ? "Add Golden Record"
            : "Add More Candidates"
        }
        buttonDisabled={isLoading || addMoreCandidateFiles.length === 0}
        buttonName={"Add New"}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <DialogCandidateHub
        open={backGroundprocess.open}
        // icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Processing"
        titlepadding={"0px 0px 16px"}
        handleClose={handlebackGroundWarningClose}
        footer={<BackGroundFooter />}
        content={
          "A background process is in progress. Please wait a few minutes while it completes."
        }
      />
      <DialogCandidateHub
        open={saveEditData.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to JEM"
        handleClose={handleSaveCandidate}
        footer={<Footer />}
        titlepadding={"0px 0px 16px"}
        content={
          "You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to proceed?"
        }
      />

      {!open && (
        <ChatBotLabelText
          title={"My name is Hailey. Ask me about this Job/Candidate"}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
}
